import { SearchSource } from '@carvana/merch-contracts';
import type { Consumer } from '~/constants/common/consumer';
import { COMPOSER_OPEN_PARAM } from '~/constants/composer';
import type { AppliedFilters } from '~/contracts/common';
import type SuggestionInfo from '~/contracts/common/SuggestionInfo';
import { getHrefWithSource } from '~/hooks/common/selectors/useGetConsumerHref';
import buildSearchLink from '~/utilities/composer/buildSearchLink';

export type ComposerSearchInput = (
  | { cvnaid: string }
  | { filters: Partial<AppliedFilters> }
) & { suggestionInfo?: Partial<SuggestionInfo> };

export default function buildComposerRedirectUrl(
  consumer: Consumer,
  input: ComposerSearchInput,
  { reopenComposer = false }: { reopenComposer?: boolean } = {}
): string {
  const searchLink = buildSearchLink(input);
  const href = getHrefWithSource(consumer)(searchLink, input.suggestionInfo);

  const [pathname, search = ''] = href.split('?');
  const params = new URLSearchParams(search);

  params.set('searchSource', SearchSource.Composer);

  if (reopenComposer) params.set(COMPOSER_OPEN_PARAM, '1');

  return `${pathname}?${params}`;
}
